const base = {
  logo: "Login to access your Account",
  fields: {
    uid: {
      info: "",
      label: "Enter your Company Key",
      required: "The field cannot be empty",
      placeholder: "Company Key"
    },
    rememberMe: "Remember me"
  },
  submit: {
    label: "Continue",
    tooltip: ""
  }
};
function getDefaultTexts(texts) {
  const loginLogo = texts?.logo;
  const loginUID = texts?.fields?.uid;
  const loginRemember = texts?.fields?.rememberMe;
  const loginBtn = texts?.submit;
  return {
    logo: loginLogo ?? base.logo,
    fields: {
      uid: {
        info: loginUID?.info ?? base.fields.uid.info,
        label: loginUID?.label ?? base.fields.uid.label,
        required: loginUID?.required ?? base.fields.uid.required,
        placeholder: loginUID?.placeholder ?? base.fields.uid.placeholder
      },
      rememberMe: loginRemember ?? base.fields.rememberMe
    },
    submit: {
      label: loginBtn?.label ?? base.submit.label,
      tooltip: loginBtn?.tooltip ?? base.submit.tooltip
    }
  };
}
export {
  getDefaultTexts
};
//# sourceMappingURL=getDefaultTexts.js.map
